module.exports = __webpack_public_path__ + "media/a3171e8cba2f4e70b34283dfc8cd7a7d.6fb86614.mp4";